import { registerNotificationCallback } from '@services/notifications/NotificationTaskService'
import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { getUserInfo } from '@services/UserInfoService'
import { getDeviceId } from '@utils/DeviceUtil'
import { AssociateNotificationServiceClient } from '@api/AssociateNotificationServiceClient'

let currentStoreId: string
let userAliasPromise: Promise<any>
let deviceIdPromise: Promise<any>

export const init = (storeId: string) => {
    console.log('ATBase AcknowledgeNotificationService init storeId: ',storeId)
    currentStoreId = storeId
    registerNotificationCallback(handleAcknowledgeNotification)
}

// public functions

/**
 * Call the AcknowledgeNotification API for each new notification received
 * @param notification The notification to publish
 * @return {promise} The promise of the notification
 */
export const handleAcknowledgeNotification = (notification: any) => {
    console.log('ATBase AcknowledgeNotificationService: Acknowledging notification ' + notification.notificationId)
    const notificationId = encodeURIComponent(notification.notificationId)

    return getUserAliasPromise()
        .then((userAlias) => {
            getDeviceIdPromise()
                .then((deviceId) => {
                    PromiseUtils.executeWithRetry(() => {
                        return acknowledgeNotification(notificationId, userAlias, deviceId)
                    })
                    .then((response: any) => {
                        console.debug('ATBase AcknowledgeNotificationService: Returned response code ' + response.status)
                    })
                    .catch((error) => {
                        console.error('ATBase AcknowledgeNotificationService: Failed with error ', error)
                    })
                })
                .catch((error) => {
                    console.error('ATBase AcknowledgeNotificationService: Failed to get device ID', error)
                })
        })
        .catch((error) => {
            console.error('ATBase AcknowledgeNotificationService: Failed to get user alias', error)
        })
}

// private functions

/**
 * Get active user information.
 * @returns {promise}   Promise resolves with an object containing active user information.
 *                      {
 *                          userAlias: "ohuerta"
 *                      }
 *                      If there is an error it rejects with the error.
 */
export const getUserAliasPromise = () => {
    userAliasPromise = getUserInfo()
        .then((userInfo) => {
            return userInfo.userAlias ? userInfo.userAlias : userInfo
        })
        .catch((e) => {
            userAliasPromise = null
            return Promise.reject(e)
        })

    return userAliasPromise
}

/**
 * Get the current device ID.
 * @returns {promise}   Promise resolves with the device ID.
 *                      If there is an error it rejects with the error.
 */
export const getDeviceIdPromise = () => {
    deviceIdPromise = getDeviceId()
        .then((deviceId) => {
            return deviceId
        })
        .catch((e) => {
            deviceIdPromise = null
            return Promise.reject(e)
        })

    return deviceIdPromise
}

export const acknowledgeNotification = (notificationId, userAlias, deviceId) => {
    console.log('ATBase AcknowledgeNotificationService: acknowledgeNotification')
    return AssociateNotificationServiceClient.getInstance().acknowledgeNotification(notificationId, userAlias, deviceId, currentStoreId)
}
